import IdentityService from '@/services/identity-service';
import { useAuthStore } from '@/store/use-auth-store';
import { useQuery } from '@tanstack/react-query';

export const useGetIdentityOrganizations = (enabled: boolean = true) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useQuery({
    queryKey: ['identity-organizations'],
    queryFn: () => IdentityService.getOrganizations(),
    enabled: enabled && isAuthenticated,
  });
};
